/**
 * Reducers specify how the application's state changes in response to actions sent to the store.
 *
 * @see https://redux.js.org/basics/reducers
 */

import { createReducer } from 'reduxsauce';
import { CreditorList01Types } from './Actions';
import INITIAL_STATE from './InitialState';

export const creditorList01ResetTimestamp = (state, { currentPage, sorts, filters, pageSize }) => ({
  ...state,
  currentPage: currentPage || state.currentPage,
  sorts: sorts || state.sorts,
  filters: filters || state.filters,
  pageSize: pageSize || state.pageSize,
  timestamp: Date.now(),
  selectedResources: INITIAL_STATE.selectedResources,
  toStorageBinOptions: INITIAL_STATE.toStorageBinOptions,
  toStorageBinOption: INITIAL_STATE.toStorageBinOption
});

export const creditorList01FetchCreditorList01Loading = (state, { boolean }) => ({
  ...state,
  fetchIsLoading: boolean
});

export const creditorList01FetchCreditorList01Success = (
  state,
  { resources, currentPage, lastPage, total, pageSize }
) => ({
  ...state,
  resources,
  currentPage,
  lastPage,
  total,
  pageSize
});

export const creditorList01AddSelectedResources = (state, { selectedResources }) => {
  const selectIds = state.selectedResources.map(value => value.id);
  return {
    ...state,
    selectedResources: [
      ...state.selectedResources,
      ...selectedResources.filter(data => {
        return !selectIds.includes(data.id);
      })
    ]
  };
};

export const creditorList01RemoveSelectedResources = (state, { selectedResources }) => {
  const selectIds = selectedResources.map(value => value.id);
  return {
    ...state,
    selectedResources: state.selectedResources.filter(data => {
      return !selectIds.includes(data.id);
    })
  };
};

export const creditorList01SetWorkspaceVisible = (state, { boolean }) => ({
  ...state,
  workspaceIsVisible: boolean
});

/**
 * @see https://github.com/infinitered/reduxsauce#createreducer
 */
export const reducer = createReducer(INITIAL_STATE, {
  [CreditorList01Types.CREDITOR_LIST01_RESET_TIMESTAMP]: creditorList01ResetTimestamp,
  [CreditorList01Types.CREDITOR_LIST01_FETCH_CREDITOR_LIST01_LOADING]: creditorList01FetchCreditorList01Loading,
  [CreditorList01Types.CREDITOR_LIST01_FETCH_CREDITOR_LIST01_SUCCESS]: creditorList01FetchCreditorList01Success,
  [CreditorList01Types.CREDITOR_LIST01_ADD_SELECTED_RESOURCES]: creditorList01AddSelectedResources,
  [CreditorList01Types.CREDITOR_LIST01_REMOVE_SELECTED_RESOURCES]: creditorList01RemoveSelectedResources,
  [CreditorList01Types.CREDITOR_LIST01_SET_WORKSPACE_VISIBLE]: creditorList01SetWorkspaceVisible
});
